import React from 'react';
import { modePatternsStyle } from './style';
import { CustomNumericFormat } from '../../../../../components';

export const MonthlyPattern = ({ inputs, handleChangeMounthDay, handleChangeMounth }) => {
    const classes = modePatternsStyle();
    const datesAreNotMentioned = !inputs.startDate || !inputs.endDate;

    return (
        <div style={datesAreNotMentioned ? { opacity: '0.5' } : {}}>
            <div className={classes.patternBoxStyle}>
                <span className={classes.weeks}>Recur day</span>
                <CustomNumericFormat
                    className={classes.smallInput}
                    name={'repeatDayMonth'}
                    value={inputs?.repeatDayMonth}
                    handleChangeMiles={(e) =>
                        handleChangeMounthDay({
                            target: {
                                name: 'repeatDayMonth',
                                value: e.floatValue,
                            },
                        })
                    }
                    noError={true}
                    disabled={datesAreNotMentioned}
                    decimalScale={0}
                />
                {/*<input*/}
                {/*   type={"number"}*/}
                {/*   value={inputs.repeatDayMonth || ""}*/}
                {/*   name={"repeatDayMonth"}*/}
                {/*   onChange={handleChangeMounthDay}*/}
                {/*   className={classes.smallInput}*/}
                {/*   disabled={datesAreNotMentioned}*/}
                {/*/>*/}
                <span className={classes.days}>of every</span>
                <CustomNumericFormat
                    className={classes.smallInput}
                    name={'repeatMonth'}
                    value={inputs?.repeatMonth}
                    handleChangeMiles={(e) =>
                        handleChangeMounth({
                            target: {
                                name: 'repeatMonth',
                                value: e.floatValue,
                            },
                        })
                    }
                    noError={true}
                    disabled={datesAreNotMentioned}
                    decimalScale={0}
                />
                {/*<input*/}
                {/*   type={"number"}*/}
                {/*   value={inputs.repeatMonth || ""}*/}
                {/*   name={"repeatMonth"}*/}
                {/*   onChange={handleChangeMounth}*/}
                {/*   className={classes.smallInput}*/}
                {/*   disabled={datesAreNotMentioned}*/}
                {/*/>*/}
                <span className={classes.days}>month(s)</span>
            </div>
        </div>
    );
};
